// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__footer__slot":"BaseModalFooter_pintxo-modal__footer__slot__8T4eU"};